__turbopack_context__.v({
  "desktopWrapper": "PlasmicFeaturesNavigation-module__QxiYaq__desktopWrapper",
  "featuresNavigationMenu": "PlasmicFeaturesNavigation-module__QxiYaq__featuresNavigationMenu",
  "h5": "PlasmicFeaturesNavigation-module__QxiYaq__h5",
  "logo__nvvZx": "PlasmicFeaturesNavigation-module__QxiYaq__logo__nvvZx",
  "logo__ubRz": "PlasmicFeaturesNavigation-module__QxiYaq__logo__ubRz",
  "logo__ytBc0": "PlasmicFeaturesNavigation-module__QxiYaq__logo__ytBc0",
  "mobileWrapper": "PlasmicFeaturesNavigation-module__QxiYaq__mobileWrapper",
  "root": "PlasmicFeaturesNavigation-module__QxiYaq__root",
});
